import { Button, Card, Checkbox, Flex, Icon, ModalManagerContext, Text } from '@pega/cosmos-react-core';
import { ModalMethods } from '@pega/cosmos-react-core/lib/components/Modal/Modal.types';
import { ColumnProps } from '@pega/cosmos-react-core/lib/components/Table/Table';
import React, { useContext, useRef } from 'react';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import { customModalProps } from '../../../../interfaces/common';
import { InteractiveText, StyledTable } from '../../../Utilities/custom.styled';
import { CustomModal } from '../../../Utilities/CustomModal';
import EditProactiveMessaging from '../Modals/EditProactiveMessaging';

const ProactiveMessagingTab: React.FC = () => {
  const { create, ModalContext } = useContext(ModalManagerContext);
  const modalMethods = useRef<ModalMethods<Partial<customModalProps>>>();
  const { dismiss } = useContext(ModalContext);
  const translate = useLocalTranslation();
  const actions = (
    <>
      <Button onClick={dismiss}>{translate('cancel')}</Button>
      <Button variant="primary" onClick={dismiss}>
        {translate('submit')}
      </Button>
    </>
  );
  const editProactiveMessaging = () => {
    modalMethods.current = create<customModalProps>(CustomModal, {
      actions: actions,
      heading: translate('edit_proactive_messaging'),
      children: () => <EditProactiveMessaging />,
    });
  };

  const data = [
    {
      id: '1234',
      message: <InteractiveText onClick={editProactiveMessaging}>Can we help you?</InteractiveText>,
      isEnabled: (
        <>
          <Flex container={{ direction: 'row', justify: 'between', alignItems: 'center' }}>
            <Checkbox checked={true} />
            <Button variant="simple" icon>
              <Icon name="trash" />
            </Button>
          </Flex>
        </>
      ),
    },
    {
      id: '12345',
      message: <InteractiveText onClick={editProactiveMessaging}>Look for something</InteractiveText>,
      isEnabled: (
        <>
          <Flex container={{ direction: 'row', justify: 'between', alignItems: 'center' }}>
            <Checkbox />
            <Button variant="simple" icon>
              <Icon name="trash" />
            </Button>
          </Flex>
        </>
      ),
    },
    {
      id: '123456',
      message: <InteractiveText onClick={editProactiveMessaging}>Contact help</InteractiveText>,
      isEnabled: (
        <>
          <Flex container={{ direction: 'row', justify: 'between', alignItems: 'center' }}>
            <Checkbox checked={true} />
            <Button variant="simple" icon>
              <Icon name="trash" />
            </Button>
          </Flex>
        </>
      ),
    },
  ];

  const columns: ColumnProps<typeof data[number]>[] = [
    { renderer: 'message', label: 'Message' },
    { renderer: 'isEnabled', label: 'Enabled' },
  ];

  const ConversationTransferTitle = () => {
    return (
      <Flex
        container={{
          direction: 'row',
          justify: 'between',
          alignItems: 'center',
        }}
      >
        <Text>{translate('select_channels_to_be_transferred_to')}</Text>
        <Button>{translate('add')}</Button>
      </Flex>
    );
  };
  return (
    <Flex
      container={{
        direction: 'column',
        itemGap: 1,
      }}
    >
      {ConversationTransferTitle()}
      <Card style={{ padding: 0 }}>
        <StyledTable hoverHighlight={true} padding={'default'} columns={columns} data={data} />
      </Card>
    </Flex>
  );
};

export default ProactiveMessagingTab;
